export const AI_PROMPTS_CHUNK = 'Ai';
